// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CollectorStatusQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
}>;

export type CollectorStatusQuery = {
  __typename?: "GraphqlQuery";
  errors: Array<{
    __typename?: "CollectorError";
    collectedAt: number;
    kind: string;
    collectorErrors?: Array<string> | null;
    snapshotErrors?: Array<string> | null;
  }>;
  connections: Array<{
    __typename?: "CollectorConnection";
    status: string;
    createdAt: number;
    age: number;
    pausedAt?: number | null;
    stoppedAt?: number | null;
    snapshots: number;
    ipAddress: string;
    version: string;
  }>;
};

export const CollectorStatusDocument = gql`
  query CollectorStatus($serverId: ID!) {
    errors: getCollectorErrors(serverId: $serverId) {
      collectedAt
      kind
      collectorErrors
      snapshotErrors
    }
    connections: getCollectorConnections(serverId: $serverId) {
      status
      createdAt
      age
      pausedAt
      stoppedAt
      snapshots
      ipAddress
      version
    }
  }
`;

/**
 * __useCollectorStatusQuery__
 *
 * To run a query within a React component, call `useCollectorStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectorStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectorStatusQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *   },
 * });
 */
export function useCollectorStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    CollectorStatusQuery,
    CollectorStatusQueryVariables
  > &
    (
      | { variables: CollectorStatusQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CollectorStatusQuery, CollectorStatusQueryVariables>(
    CollectorStatusDocument,
    options,
  );
}
export function useCollectorStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CollectorStatusQuery,
    CollectorStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CollectorStatusQuery,
    CollectorStatusQueryVariables
  >(CollectorStatusDocument, options);
}
// @ts-ignore
export function useCollectorStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CollectorStatusQuery,
    CollectorStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CollectorStatusQuery,
  CollectorStatusQueryVariables
>;
export function useCollectorStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CollectorStatusQuery,
        CollectorStatusQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CollectorStatusQuery | undefined,
  CollectorStatusQueryVariables
>;
export function useCollectorStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CollectorStatusQuery,
        CollectorStatusQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CollectorStatusQuery,
    CollectorStatusQueryVariables
  >(CollectorStatusDocument, options);
}
export type CollectorStatusQueryHookResult = ReturnType<
  typeof useCollectorStatusQuery
>;
export type CollectorStatusLazyQueryHookResult = ReturnType<
  typeof useCollectorStatusLazyQuery
>;
export type CollectorStatusSuspenseQueryHookResult = ReturnType<
  typeof useCollectorStatusSuspenseQuery
>;
export type CollectorStatusQueryResult = Apollo.QueryResult<
  CollectorStatusQuery,
  CollectorStatusQueryVariables
>;
